"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fail = exports.FAIL_STYLE_TYPE = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Message = require("./Message");
require("./Fail.scss");
var FAIL_STYLE_TYPE = /*#__PURE__*/function (FAIL_STYLE_TYPE) {
  FAIL_STYLE_TYPE["inline"] = "inline";
  FAIL_STYLE_TYPE["fill"] = "fill";
  FAIL_STYLE_TYPE["fullScreen"] = "fullScreen";
  FAIL_STYLE_TYPE["tableRow"] = "tableRow";
  return FAIL_STYLE_TYPE;
}(FAIL_STYLE_TYPE || {});
exports.FAIL_STYLE_TYPE = FAIL_STYLE_TYPE;
var Fail = function Fail(_ref) {
  var className = _ref.className,
    message = _ref.message,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? FAIL_STYLE_TYPE.inline : _ref$styleType;
  var Message = Fail.Message;
  var rootClassName = (0, _classnames["default"])('cds-Fail', ["cds-Fail--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType))], className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement(Message, null, message));
};
exports.Fail = Fail;
Fail.Message = _Message.Message;
Fail.config = {
  styleType: FAIL_STYLE_TYPE
};